<template>
    <!-- Login -->
    <v-container v-if="tpl == 'login' ">
        <v-row>
            <v-col
                    cols="12"
            >
                <p class="font-weight-bold mb-6 text-center display-2">Login or Sign Up</p>
                <hr>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" lg="4" md="3" sm="3"></v-col>
            <v-col
                    cols="12"
                    lg="4"
                    md="6"
                    sm="6"
                    xs="12"
                    class="text-center"
            >
                <v-form
                        ref="form"
                        onsubmit="return false"
                >
                    <v-text-field
                            v-model="customer.email"
                            maxlength="200"
                            :rules="emailRules"
                            label="Email"
                            v-on:keyup.enter="loginEmail"
                            required
                    ></v-text-field>
                    <v-text-field
                            v-if="existCustomer"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'"
                            hint="At least 8 characters"
                            @click:append="show1 = !show1"
                            v-model="customer.password"
                            maxlength="100"
                            counter="100"
                            :rules="passwordRules"
                            label="Password"
                            v-on:keyup.enter="loginPassword"
                            required
                    ></v-text-field>
                    
                    <div v-if="erro">
                        <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                            {{ item }}
                        </v-alert>
                        <v-alert type="error" dense outlined >
                            <v-btn text @click="forgot" color="error">I forgot my password</v-btn>
                        </v-alert>
                    </div>
                    <div v-else>
                        <v-alert type="success" dense outlined  v-for="(item,index) in msg" :key="index">
                            {{ item }}
                        </v-alert>
                    </div>
                    <v-btn
                            v-if="existCustomer"
                            :loading="loading.login"
                            color="success"
                            class="mr-4"
                            @click="loginPassword"
                    >
                        <span>Login</span>
                    </v-btn>
                    <v-btn
                            v-else
                            :loading="loading.login"
                            color="success"
                            class="mr-4"
                            @click="loginEmail"
                    >
                        <span>Continue</span>
                    </v-btn>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
    <!-- create -->
    <v-form v-else-if="tpl == 'create'"
            ref="formCreate"
    >
        <v-container >
            <v-row>
                <v-col
                        cols="12"
                >
                    <p class="font-weight-bold mb-6 text-center display-2">Sign Up</p>
                    <hr>
                </v-col>
                <v-col
                        cols="6"
                        md="3"
                        class="text-center"
                >
                    <v-text-field
                            v-model="customer.name"
                            maxlength="200"
                            counter="200"
                            :rules="nameRules"
                            label="Name"
                            required
                    ></v-text-field>
                </v-col>
                <v-col
                        cols="6"
                        md="3"
                        class="text-center"
                >
                    <v-text-field
                            v-model="customer.email"
                            readonly
                            maxlength="200"
                            counter="200"
                            label="Email"
                            required
                    ></v-text-field>
                </v-col>
                <v-col
                        cols="6"
                        md="3"
                        class="text-center"
                >
                    <v-text-field
                            v-model="customer.telephone"
                            maxlength="50"
                            label="Telephone"
                            v-mask="['(###) ###-####']"
                    ></v-text-field>
                </v-col>
                <v-col
                        cols="6"
                        md="3"
                        class="text-center"
                >
                    <v-text-field
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'"
                            hint="At least 8 characters"
                            @click:append="show1 = !show1"
                            v-model="customer.password"
                            maxlength="100"
                            counter="100"
                            :rules="passwordRules"
                            label="Password"
                            required
                    ></v-text-field>
                </v-col>
                <v-col
                        cols="12"
                        class="text-center"
                >
                    <div v-if="erro">
                        <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                            {{ item }}
                        </v-alert>
                    </div>
                    <div v-else>
                        <v-alert type="success" dense outlined  v-for="(item,index) in msg" :key="index">
                            {{ item }}
                        </v-alert>
                    </div>
                    <v-btn
                            :loading="loading.register"
                            color="success"
                            class="mr-4"
                            @click="registerEmail"
                    >
                        <span>Continue</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
    <!--Logged-->
    <v-container v-else-if="tpl == 'logged'">
        <v-row>
            <v-col
                    cols="12"
            >
                <p class="font-weight-bold mb-6 text-center display-2">
                    Hello, {{ customer.name }}
                    <v-btn fab class="float-right" dark large color="indigo" @click="logout"><v-icon>mdi-logout</v-icon></v-btn>
                </p>
                <hr>
            </v-col>
            <v-col cols="12">
                <v-card
                        flat
                        tile
                >
                    <v-card-text>
                        <v-list-group v-for="(order,index) in orders" :key="index" value="true">
                        <template v-slot:activator>
                            <v-list-item-title>
                                Order {{ order.id }} -
                                <span>{{ order.name_status }}</span>
                                - {{ order.date_order }}
                            </v-list-item-title>
                        </template>
                        <v-list-item>
                            <v-row>
                                <v-col cols="12">
                                    <v-card>
                                        <v-row style="font-weight: bold;" class="d-none d-sm-flex">
                                            <v-col
                                                    cols="5"
                                                    class="text-center"
                                            >
                                                <span>Product</span>
                                            </v-col>
                                            <v-col
                                                    cols="2"
                                                    class="text-center"
                                            >
                                                <span >Price</span>
                                            </v-col>
                                            <v-col
                                                    cols="2"
                                                    class="text-center"
                                            >
                                                <span>Qty</span>
                                            </v-col>
                                            <v-col
                                                    cols="2"
                                                    class="text-center"
                                            >
                                                <span>Total</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-for="(item, i) in order.products" :key="i+'p'">
                                            <v-col
                                                    cols="12"
                                                    sm="5"
                                                    class="text-center"
                                            >
                                                <v-img :src="cdnUrl+'/products/'+item.image" height="60px" width="60px" style="margin: 0 auto"></v-img>
                                                <span >{{ item.name }}</span>
                                            </v-col>
                                            <v-col
                                                    cols="12"
                                                    sm="2"
                                                    class="text-center"
                                            >
                                                ${{ item.value | number_format_real }}
                                            </v-col>
                                            <v-col
                                                    cols="12"
                                                    sm="2"
                                                    class="text-center"
                                            >
                                                {{ item.qty }}x
                                            </v-col>
                                            <v-col
                                                    cols="12"
                                                    sm="2"
                                                    class="text-center"
                                            >
                                                ${{ item.value*item.qty | number_format_real }}
                                            </v-col>
                                            <v-col cols="12">
                                                <v-divider :key="index+'a'"></v-divider>
                                            </v-col>
                                        </v-row>
                                        <v-row style="font-weight: bold;" v-if="order.tax">
                                            <v-col
                                                    cols="12"
                                                    class="font-weight-bold title"
                                            >
                                                <span class="float-right">Total Products: ${{ order.subtotal | number_format_real}}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row style="font-weight: bold;" v-if="order.tax">
                                            <v-col
                                                    cols="12"
                                                    class="font-weight-bold title"
                                            >
                                                <span class="float-right">Tax: ${{ order.tax | number_format_real}}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row style="font-weight: bold;">
                                            <v-col
                                                    cols="12"
                                                    class="font-weight-bold title"
                                            >
                                                <span class="float-right">Address:
                                                        {{order.endereco}} {{order.gatecode}} - {{order.cidade}} {{order.estado}} - {{order.zipcode}}
                                                    <br>
                                                </span>
                                            </v-col>
                                            <v-col
                                                    cols="12"
                                                    class="font-weight-bold title"
                                            >
                                                <span class="float-right">Shipping:
                                                    
                                                    <span v-if="order.shipping"> ${{ order.shipping | number_format_real}} {{order.service_shipping}}</span>
                                                    <span v-else>Free</span>
                                                </span>
                                            </v-col>
                                        </v-row>
                                        <v-row style="font-weight: bold;">
                                            <v-col
                                                    cols="12"
                                                    class="font-weight-bold title"
                                            >
                                                <span class="float-right">Total: ${{ order.total | number_format_real}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        </v-list-group>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    <!--Loading-->
    <v-container v-else-if="tpl == 'loading' ">
        <v-row>
            <v-col
                    cols="12"
            >
                <v-card loading>
                    <v-card-text>
                        &nbsp;
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mask } from 'vue-the-mask';
    export default {
        directives: {
            mask
        },
        props: {
            lang: { type: String },
            cart: { type: Object },
            appUrl:{ type: String},
            cdnUrl:{ type: String},
        },
        metaInfo () {
            return {
                title: 'PPS Healthcare - Account',
                meta: [
                    {description: 'PPS Healthcare - Account'},
                    {keywords: 'PPS Healthcare - Account'}
                ]
            }
        },
        data () {
            return {
                show1: false,
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
                ],
                nameRules: [
                    v => !!v || 'Name is required'
                ],
                passwordRules: [
                    v => !!v || 'password is required',
                    v => v.length >= 8 || 'Min 8 characters',
                ],
                existCustomer:false,
                customer:{
                    email:"",
                    name:"",
                    telephone:"",
                    password:""
                },
                orders:{},
                msg:[],
                erro:false,
                loading:{
                    login:false,
                    register:false,
                },
                tpl:'loading'
            }
        },
        methods:{
            loginFacebook(email,name){
                var arr = {
                    email:email,
                    name:name
                };
                arr = JSON.stringify(arr);
                this.$http.post(this.appUrl+"/store/customer/facebook",arr).then(response => {
                    this.loading.login = false;
                    if(response.data.erro == '0'){
                        localStorage.hash = response.data.data;
                        this.checkLogin();
                    }
                });
            },
            fbTest(){
                var self = this;
                window.loginFB = function () {
                    window.FB.login(function(response) {
                        if (response.status === 'connected') {
                            window.FB.api('/me',{fields: 'name, email'}, function(response) {
                                self.loginFacebook(response.email,response.name);
                            });
                        }
                    }, {scope: 'public_profile,email'});
                    return false;
                }
            },
            registerEmail(){
                if (this.$refs.formCreate.validate()) {
                    this.loading.register = true;
                    var arr = JSON.stringify(this.customer);
                    this.$http.post(this.appUrl+"/store/customer/create",arr).then(response => {
                        this.loading.register = false;
                        if(response.data.erro == '1'){
                            this.erro = true;
                            this.msg = response.data.msg;
                        }else{
                            localStorage.hash = response.data.data;
                            this.checkLogin();
                        }
                    });
                }
            },
            loginEmail(){
                if (this.$refs.form.validate()) {
                    var arr = {
                        email:this.customer.email
                    };
                    arr = JSON.stringify(arr);
                    this.erro = false;
                    this.msg = [];
                    this.loading.login = true;
                    this.$http.post(this.appUrl+"/store/customer/email",arr).then(response => {
                        this.loading.login = false;
                        if(response.data.erro == '1'){
                            this.erro = true;
                            this.msg = response.data.msg;
                        }else{
                            //check user
                            if(response.data.data.id){
                                console.log("user exist");
                                this.existCustomer = true;
                            }else{
                                this.tpl = 'create';
                                console.log("new user");
                            }
                        }
                    });
                }
            },
            loginPassword(){
                if (this.$refs.form.validate()) {
                    var arr = {
                        email:this.customer.email,
                        password:this.customer.password,
                    };
                    arr = JSON.stringify(arr);
                    this.erro = false;
                    this.msg = [];
                    this.loading.login = true;
                    this.$http.post(this.appUrl+"/store/customer/password",arr).then(response => {
                        this.loading.login = false;
                        if(response.data.erro == '1'){
                            this.erro = true;
                            this.msg = response.data.msg;
                        }else{
                            localStorage.hash = response.data.data.hash;
                            this.checkLogin();
                        }
                    });
                }
            },
            checkLogin(){
                if (localStorage.hash) {
                    //check hasg
                    var arr = {
                        hash:localStorage.hash
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post(this.appUrl+"/store/customer/hash",arr).then(response => {
                        if(response.data.erro == '1'){
                            if(this.tpl == 'logged'){
                                //this.tpl = 'login';
                            }
                            this.tpl = 'login';
                            //console.log("Invalid Hash");
                        }else{
                            this.tpl = 'logged';
                            this.customer.name = response.data.data.name;
                            this.orders = response.data.data.orders;
                            //console.log("Hash ok");
                        }
                    });
                }else{
                    this.tpl = 'login';
                }
            },
            logout(){
                localStorage.removeItem('hash');
                this.customer.email = "";
                this.customer.password = "";
                this.checkLogin();
            },
            forgot(){
                if (this.$refs.form.validate()) {
                    var arr = {
                        email:this.customer.email
                    };
                    arr = JSON.stringify(arr);
                    this.erro = false;
                    this.msg = [];
                    this.loading.login = true;
                    this.$http.post(this.appUrl+"/store/customer/forgot",arr).then(response => {
                        this.loading.login = false;
                        if(response.data.erro == '1'){
                            this.erro = true;
                        }
                        this.msg = response.data.msg;
                    });
                }
            }
        },
        mounted(){
            this.$emit('showCart');
            //localStorage.removeItem('hash');
            this.checkLogin();
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>